import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'
import { EventsContext, FilterOptions } from './EventsProvider'

interface ToolbarProps {
  onFilterChange: (filter: string) => void
}

function FilterEventsButtonsMobile({ onFilterChange }: ToolbarProps) {
  const { loadingEvents, selectedFilter, showSearchFilterButton } = useContext(EventsContext)

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    onFilterChange(event.target.value as FilterOptions)
  }

  return (
    <>
      <FormControl fullWidth size="small">
        <Select
          size="small"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedFilter}
          defaultValue="daily"
          onChange={handleSelectChange}
          disabled={loadingEvents}
          sx={{
            fontSize: '16px',
          }}
        >
          <MenuItem value="daily" sx={{ fontSize: '16px' }}>
            Dagens
          </MenuItem>
          <MenuItem value="incident" sx={{ fontSize: '16px' }}>
            Fellesfeil
          </MenuItem>
          <MenuItem value="planned" sx={{ fontSize: '16px' }}>
            Planlagt
          </MenuItem>
          <MenuItem value="generic" sx={{ fontSize: '16px' }}>
            Generell
          </MenuItem>
          <MenuItem value="all" sx={{ fontSize: '16px' }}>
            Alle
          </MenuItem>
          {showSearchFilterButton && (
            <MenuItem value="search" sx={{ fontSize: '16px' }}>
              Søk
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  )
}

export default FilterEventsButtonsMobile
